import * as PlayState from './constants/PlayState'
import * as ObjectType from './constants/ObjectType'

/**
 * This represents an episode, its ads, and other data that is necessary for the
 * player to be able to function properly.
 */
export class PlayObject {
  constructor(indexInList, episode, preRollAds, midRollAds) {
    this.episodeIndex = indexInList
    this.episode = episode
    this.currentMidroll = -99
    this.preRollAds = preRollAds
    this.midRollads = midRollAds
    this.idOfLastPlayedAd = '-1'
    this.playState = PlayState.NOT_STARTED
    this.currentObjectType = ObjectType.NONE
  }
}



// WEBPACK FOOTER //
// ./src/components/AudioPlayer/model/PlayObject.js